// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { FieldsFactory } from "../Factory/FieldsFactory.js"
import { MessageProcessorBase } from "./MessageProcessorBase.ts"
import { DirectQuote4Message } from "../../../../Utils/DirectMessages/DirectQuote4Message.js"
import { Quote1MessageProcessor } from "./Quote1MessageProcessor.js"
export let Quote4MessageProcessor = function (decoder, advancedTableContainer)
{
    MessageProcessorBase.call(this)
    this.decoder = decoder
    this.l1Processor = new Quote1MessageProcessor(decoder, advancedTableContainer)
}

Quote4MessageProcessor.prototype = Object.create(MessageProcessorBase.prototype)

Quote4MessageProcessor.prototype.decode = function (fieldSet)
{
    let factory = FieldsFactory
    let decoder = this.decoder
    let symDecodeMap = decoder.InstrumentDecodeMap
    let l1Processor = this.l1Processor

    let message = new DirectQuote4Message()

    // на сервере сначала символ=GOOG115CALLDec8, потом андерлайер=GOOG
    // только они называют их наоборот
    message.Symbol = fieldSet.GetValue(factory.FIELD_UNDERLIER)

    let tickId = fieldSet.GetValue(factory.FIELD_INSTRUMENT_ID)
    message.Underlier = symDecodeMap[tickId] || ''

    let routeId = fieldSet.GetValue(factory.FIELD_ROUTE_ID)
    message.Route = routeId;//decoder.GetRouteById(routeId)

    message.Bid = fieldSet.GetValue(factory.FIELD_BID)

    let fieldBidVolume = fieldSet.GetValue(factory.FIELD_BID_VOLUME)
    message.BidSize = fieldBidVolume === null
        ? fieldSet.GetValue(factory.FIELD_BID_SIZE)
        : fieldBidVolume

    message.Ask = fieldSet.GetValue(factory.FIELD_ASK)

    let fieldAskVolume = fieldSet.GetValue(factory.FIELD_ASK_VOLUME)
    message.AskSize = fieldAskVolume === null
        ? fieldSet.GetValue(factory.FIELD_ASK_SIZE)
        : fieldAskVolume

    message.Open = fieldSet.GetValue(factory.FIELD_OPEN)
    message.High = fieldSet.GetValue(factory.FIELD_HIGH)
    message.Low = fieldSet.GetValue(factory.FIELD_LOW)
    message.PrevClose = fieldSet.GetValue(factory.FIELD_PRE_CLOSE)

    message.Volume = fieldSet.GetValue(factory.FIELD_VOLUME_TOTAL)
    message.Last = fieldSet.GetValue(factory.FIELD_LAST_PRICE)
    message.LastSize = fieldSet.GetValue(factory.FIELD_LAST_SIZE)

    message.OpenInterest = fieldSet.GetValue(factory.FIELD_OPEN_INTEREST)
    message.cTime = fieldSet.GetValue(factory.FIELD_DATE)

    message.InstrumentTradableID = fieldSet.GetValue(factory.FIELD_TRADABLE_INSTRUMENT_ID)

    // для сгенерированных инструментов
    let level1 = l1Processor.decode(fieldSet)
    return [message, level1[0], level1[1]]
}
